import i18n from "../../constants/i18n";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Text from "../../core/et3-text";
import getCoreLoginStore from "../../stores/core/core-login-store";

const SignInError = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;

  const error = i18n.get(getCoreLoginStore().errorKey.get());

  return (
    <Et3Text
      fontFamily={"BOLD"}
      fontSize={25}
      text={error}
      isSpan={false}
      color={colors.all.red}
      style={{}}
    />
  );
});
export default SignInError;
